import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'

// Each variant has its own icon and label, so they can be told apart
// without relying on colour.
const VARIANTS = {
  keyFact: { label: 'Key fact', Icon: LightbulbOutlinedIcon, colour: colours.accent, soft: colours.accentSoft },
  legalDuty: { label: 'Legal duty', Icon: GavelOutlinedIcon, colour: colours.bad, soft: colours.badSoft },
  inPractice: { label: 'In practice', Icon: TipsAndUpdatesOutlinedIcon, colour: colours.good, soft: colours.goodSoft },
}

const Callout = ({ block }) => {
  const { label, Icon, colour, soft } = VARIANTS[block.variant] ?? VARIANTS.keyFact
  return (
    <Box sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 1, bgcolor: soft, borderLeft: `6px solid ${colour}`, maxWidth: '74ch' }}>
      <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '1rem', fontWeight: 700, color: colour, mb: 1 }}>
        <Icon aria-hidden="true" />
        {label}
      </Typography>
      <Markdown sx={bodyText}>{block.body}</Markdown>
    </Box>
  )
}

export default Callout
